/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import type {
  GetGuides200,
  GetLayout200,
  PatchGuides200,
  PatchGuidesBody,
  PatchLayout200,
  PatchLayoutBody,
  UserMeDTO,
} from "../schemas";

import { customInstance } from "../../config/mutator";

export const getUser = () => {
  /**
   * Logout the user and invalidate the authorization token
   */
  const logout = () => {
    return customInstance<void>({ url: `/api/users/logout`, method: "POST" });
  };
  /**
   * Get the current user's table layout preferences
   */
  const getLayout = () => {
    return customInstance<GetLayout200>({ url: `/api/users/layout`, method: "GET" });
  };
  /**
   * Reset the current user's table layout preferences to defaults
   */
  const deleteLayout = () => {
    return customInstance<void>({ url: `/api/users/layout`, method: "DELETE" });
  };
  /**
   * Partially update the current user's table layout preferences (shallow merge at top level, replace at table level)
   */
  const patchLayout = (patchLayoutBody: PatchLayoutBody) => {
    return customInstance<PatchLayout200>({
      url: `/api/users/layout`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: patchLayoutBody,
    });
  };
  /**
   * Get the current user's guides: named boolean properties that keep dismissed guide popups in UI
   */
  const getGuides = () => {
    return customInstance<GetGuides200>({ url: `/api/users/guides`, method: "GET" });
  };
  /**
   * Reset the current user's guides to defaults
   */
  const deleteGuides = () => {
    return customInstance<void>({ url: `/api/users/guides`, method: "DELETE" });
  };
  /**
   * Partially update the current user's guides (shallow merge at top level)
   */
  const patchGuides = (patchGuidesBody: PatchGuidesBody) => {
    return customInstance<PatchGuides200>({
      url: `/api/users/guides`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: patchGuidesBody,
    });
  };
  /**
   * Get current user details
   */
  const getAccount = () => {
    return customInstance<UserMeDTO>({ url: `/api/users/me`, method: "GET" });
  };
  return {
    logout,
    getLayout,
    deleteLayout,
    patchLayout,
    getGuides,
    deleteGuides,
    patchGuides,
    getAccount,
  };
};
export type LogoutResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getUser>["logout"]>>>;
export type GetLayoutResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getUser>["getLayout"]>>
>;
export type DeleteLayoutResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getUser>["deleteLayout"]>>
>;
export type PatchLayoutResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getUser>["patchLayout"]>>
>;
export type GetGuidesResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getUser>["getGuides"]>>
>;
export type DeleteGuidesResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getUser>["deleteGuides"]>>
>;
export type PatchGuidesResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getUser>["patchGuides"]>>
>;
export type GetAccountResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getUser>["getAccount"]>>
>;
